import Rating from '../rating/Rating';
import {useLocation} from 'react-router-dom';
import UpgradePermissionPopup from '../upgradePermissionPopup/UpgradePermissionPopup';
import useShow from '../../../hooks/useShow';
import Package from '../../package/pages/Package';
import {packageList} from '../../../layout/events/packageManagement/PackageManagement';
import Security from '../security/Security';
import Welcome from '../../login/signIn/Welcome/Welcome';
import UserMessage from '../../../layout/userMessages/UserMessage';
import UserMessageBlock from '../../../layout/userMessagesBlock/UserMessageBlock';
import VerificationAccountPopup from '../../popups/verificationAccount/VerificationAccountPopup';
import TeamMemberPop from '../../team/teamMemberPop/TeamMemberPop';
import {POPUP_DURATION} from '../../../globalVariables/GlobalVariables';
import EasyCourseFirstScreen from '../../createCourseEvent/easyCourseFirstScreen/EasyCourseFirstScreen';
import useGlobalShow from '../../../hooks/useGlobalShow';
import TickchakLoader from '../../../component/tickchakLoader/TickchakLoader';
import DesignPopup from '../../../component/designPopup/DesignPopup';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import WrapReportCash from '../../cash/reportCash/WrapReportCash';
import CrowdSearch from '../../crowds/crowdSearch/crowdSearch';
import ArrivalConfirmationPopup from '../../../component/arrivalConfirmationPopup/ArrivalConfirmationPopup';
import LeadSendPopup from '../../../pages/lead/leadSendPopup/LeadSendPopup';
import InvoiceSendPopup from '../../../pages/invoice/invoiceSendPopup/InvoiceSendPopup';
// import DesignLandingPopup from '../../../component/designLandingPopup/DesignLandingPopup';

function UniversalPopups() {
    const location = useLocation();
    let params = new URLSearchParams(location.search);
    const packagePage = params.get('packagePage');
    const verificationPop = params.get('verificationPop');
    const teamMemberPop = params.get('teamMemberPop');

    const packageShow = useShow();
    const teamAboutShow = useShow(POPUP_DURATION);
    const openCourseStart = useGlobalShow('isOpenEasyCourseStart',POPUP_DURATION);
    const showLoader = useGlobalShow('isOpenTickchakLoader');
    const showDesignPop = useGlobalShow('isOpenDesignPop');
    const showReportCash = useGlobalShow('isOpenReportCash');
    const showCrowdSearch = useGlobalShow('isOpenCrowdSearch');
    const showArrivalConfirmation = useGlobalShow('isOpenArrivalConfirmation');
    const showLeadsSending = useGlobalShow('isOpenLeadsSending');
    const showInvoiceSending = useGlobalShow('isOpenInvoiceSending');
    const verificationShow = useShow();
    const navigate = useNavigate();

    useEffect(() => {
        if(!packagePage)
            return;
        if([...packageList,{text:'team'}].some(p => p.text === packagePage)) 
            packageShow.open();       
        else {
            if(packageShow.isOpen)
                packageShow.close();
            navigate(location.pathname);
        }  
    }, [packagePage]);

    useEffect(() => {
        if(verificationPop && verificationPop==='open')
            verificationShow.open();
    }, [verificationPop]);

    useEffect(() => {
        if(teamMemberPop){
            teamAboutShow.open();
        }
    }, [teamMemberPop]);

    return (
        <>
            {showDesignPop.isOpen&& <DesignPopup show={showDesignPop}/>}
            {showLoader.isOpen&& <TickchakLoader showClass={showLoader.showClass} cssStyle={'position:fixed ;'}/>}
            <UserMessage/>   
            <UserMessageBlock/>
            <Welcome />
            <Security/>
            {packageShow.isOpen && <Package packageShow={packageShow}/>}
            {verificationShow.isOpen && <VerificationAccountPopup show={verificationShow}/>}
            {teamAboutShow.isOpen && <TeamMemberPop showClass={teamAboutShow.showClass} close={teamAboutShow.close}/>}
            {openCourseStart.isOpen && <EasyCourseFirstScreen openPop={openCourseStart}/>}
            <Rating />
            <UpgradePermissionPopup />
            {showReportCash.isOpen&&<WrapReportCash show={showReportCash}/>}
            {showCrowdSearch.isOpen&&<CrowdSearch  show={showCrowdSearch}/>}
            {showArrivalConfirmation.isOpen && <ArrivalConfirmationPopup show={showArrivalConfirmation} />}
            {/* <DesignLandingPopup /> */}
            {showLeadsSending.isOpen && <LeadSendPopup show={showLeadsSending}/>}
            {showInvoiceSending.isOpen && <InvoiceSendPopup show={showInvoiceSending}/>}
        </>
    );
}
export default UniversalPopups;
